import styled from 'styled-components';

export const Container = styled.section``;

export const Content = styled.article``;
